import { Injectable } from "@angular/core";
import { MaintenanceViewModel } from "../core";
import { BehaviorSubject, map, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { brdCatchError } from "../shared/message-utils";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class MaintenanceService {
  private maintenanceSubject = new BehaviorSubject<MaintenanceViewModel>({});
  maintenance$ = this.maintenanceSubject.asObservable();

  controllerName = "Maintenance";
  private apiUrl: string = `${environment.API}/${this.controllerName}`;

  constructor(private readonly httpClient: HttpClient) {}

  getMaintenance(): Observable<MaintenanceViewModel> {
    return this.httpClient.get<MaintenanceViewModel>(`${this.apiUrl}`).pipe(
      map(res => {
        this.maintenanceSubject.next(res ?? {});
        return res;
      })
    );
  }

  updateMaintenance(maintenance: MaintenanceViewModel): Observable<MaintenanceViewModel> {
    return this.httpClient.post<MaintenanceViewModel>(`${this.apiUrl}`, maintenance).pipe(
      brdCatchError(),
      map(res => {
        this.maintenanceSubject.next(res);
        return res;
      })
    );
  }

  removeMaintenance(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${this.apiUrl}/${id}`).pipe(
      brdCatchError(),
      map(() => {
        this.maintenanceSubject.next({});
      })
    );
  }
}
